import { useModalContentToggler } from '@components'

import { Button, Flex, notify, Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { NotificationKeys } from '../../../../../../../../../../enums/notificationKeys'
import { useCustomerForm } from '../../../../../../contexts/customerFormContext'

export const EditContactPersonModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { contactPersonIdToEdit, isLoading, isSubmitting, updateContactPerson } = useCustomerForm()
  const { prevState, setActiveState } = useModalContentToggler()

  const handleSaveButtonClick = useCallback(() => {
    if (!contactPersonIdToEdit) {
      return
    }

    const isContactPersonEdited = updateContactPerson(contactPersonIdToEdit)

    if (!isContactPersonEdited) {
      notify({
        id: NotificationKeys.MultipleContacts,
        message: t('customer_modal.edit_contact.error_message'),
        variant: 'error',
      })
      return
    }

    notify({
      id: NotificationKeys.MultipleContacts,
      message: t('customer_modal.edit_contact.label'),
      variant: 'success',
    })

    setActiveState(prevState)
  }, [contactPersonIdToEdit, prevState, setActiveState, t, updateContactPerson])

  const handleBackButtonClick = useCallback(() => {
    setActiveState(prevState)
  }, [prevState, setActiveState])

  return (
    <Flex justifyContent="flex-end" width="100%" gap={Spacing.S8}>
      <Button variant="outlined" disabled={isLoading || isSubmitting} onClick={handleBackButtonClick}>
        {t('back')}
      </Button>
      <Button disabled={isLoading || isSubmitting} loading={isSubmitting} onClick={handleSaveButtonClick}>
        {t('customer_modal.form.company_persons.modal.update_button.label')}
      </Button>
    </Flex>
  )
}
